module.exports = __webpack_public_path__ + "static/img/title_ADorg@2x.439e32f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity_template/title_ADorg@2x.png
// module id = XO7X
// module chunks = 0